import { HorizontalDotsMinor } from '@shopify/polaris-icons'
import React, { memo, useCallback, useContext, MouseEvent } from 'react'
import { Button } from 'src/components/shared/Button'
import { OpportunityCandidate } from 'src/interfaces/opportunity'
import { CandidatePoolTableContext } from './CandidatePoolTable.context'

interface Props {
  candidate: OpportunityCandidate
}

const CandidateActionButtonComponent = ({ candidate }: Props) => {
  const { openCandidateItemAction } = useContext(CandidatePoolTableContext)

  const handleClickAction = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      openCandidateItemAction(event, candidate)
    },
    [candidate, openCandidateItemAction],
  )

  return (
    <Button
      color="white"
      size="tiny"
      leftIcon={<HorizontalDotsMinor width={20} height={20} />}
      onClick={handleClickAction}
      data-testid={`candidate-pool-row-${candidate.id}-actions-btn`}
    />
  )
}

export const CandidateActionButton = memo(CandidateActionButtonComponent)
